import React from 'react';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
      title: 'Reinforcement Learning Agent',
      description: 'RL projects featuring DQN, PPO, and Unity ML-Agents implementations. Agents are trained across diverse environments, from a Pygame-based Chrome Dino game (gymnasium) to Minecraft tasks (MineRL PPO) and Unity 2D navigation (ML-Agents). Includes environment setup, training scripts, and evaluation tools.',
      tools: ['mineRL', 'PPO', 'DQN', 'ML-Agents', 'Python'],
      github: 'https://github.com/yohannestayez/Reinforcement-Learning.git'
    },
    {
      title: 'Dorners-Psi',
      description: 'An AI-powered chatbot that uses vector search, LangChain, Qdrant, and Google Gemini to enable dynamic, emotionally engaging conversations with book characters.',
      tools: ['Gemini LLM', 'Flask', 'Qdrant', 'LangChain'],
      github: 'https://github.com/yohannestayez/Dorners-Psi.git'
    },
    {
      title: 'Personalized Recommendation System',
      description: 'A hybrid personalized recommendation system that fuses BERT-based semantic content embeddings with a Graph Neural Network powered collaborative filtering to deliver richer, more accurate user-item recommendations.',
      tools: ['PyTorch', 'pandas', 'numpy', 'transformers',],
      github: 'https://github.com/yohannestayez/Personalized-recommendation.git'
    },
    {
      title: 'Fraud Detection System',
      description: 'Fraud detection system for e-commerce and banking transactions using machine learning and deep learning techniques.',
      tools: ['Pandas', 'NumPy', 'Scikit-learn', 'PyTorch', 'MLflow'],
      github: 'https://github.com/yohannestayez/Improved-detection-of-fraud-cases-for-e-commerce-and-bank-transactions.git'
    },
    {
      title: 'Brent Oil Price Analysis',
      description: 'Statistical modeling and time series analysis of Brent oil prices using advanced forecasting techniques.',
      tools: ['Statsmodels', 'pmdarima', 'Scikit-learn', 'Pandas'],
      github: 'https://github.com/yohannestayez/statistical-modelling-of-time-series-data.git'
    },
    {
      title: 'Spam Text Classification',
      description: 'Implemented a Predictive Coding Network (PCN) for SMS spam classification using the ngclearn library. Inspired by neural processing, the PCN, with two hidden layers, was trained on preprocessed data using Hebbian learning.',
      tools: ['ngclearn', 'Python'],
      github: 'https://github.com/yohannestayez/SMS-messages-classificaiton-with-PCN.git'
    },
  ];

  return (
    <div className="projects">
      <h2 className="section-title">Projects</h2>
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div key={index} className="project-card">
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            <div className="project-tech">
              {project.tools.map((tool, toolIndex) => (
                <span key={toolIndex} className="tech-tag">{tool}</span>
              ))}
            </div>
            <a href={project.github} target="_blank" rel="noopener noreferrer" className="project-link">
              View on GitHub
            </a>
          </div>
        ))}
      </div>
      <div className="github-section">
        <h3>Check Out More Projects</h3>
        <p>Explore more of my work and contributions on GitHub</p>
        <a 
          href="https://github.com/yohannestayez" 
          target="_blank" 
          rel="noopener noreferrer"
          className="github-button"
        >
          Visit My GitHub Profile
        </a>
      </div>
    </div>
  );
};

export default Projects;
